<template>
  <div class="button-group">
    <Button
      :title="'Cancel'"
      :type="'raised'"
      :colorTheme="'secondary'"
      @button-click="$emit('cancelActiveFiltersForm')"
    />
    <Button
      :title="'Reset'"
      :type="'raised'"
      :colorTheme="'secondary'"
      @button-click="$emit('resetActiveFilters')"
    />
    <Button
      :title="'Save'"
      :type="'raised'"
      :colorTheme="'primary'"
      @button-click="$emit('saveActiveFilters')"
    />
  </div>
</template>
<script>
import Button from '@/components/form-elements/Button'

export default {
  name: 'FilterButtons',
  components: {
    Button
  }
}
</script>
<style scoped lang="scss">
@import '../../assets/styles/mixin';

.button-group {
  @include flex(row, flex-end, center);

  button {
    margin-left: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form-elements/FilterButtons.vue